import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2 } from 'lucide-react';
import { MetaTags } from '../../../../components/SEO/MetaTags';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
export function BlogPostEmotionalDrainPart2ES() {
  const articleData = {
    title: '¿Por qué algunas personas nos hacen sentir agotados? Parte 2',
    description: 'Más patrones sutiles que agotan tu energía. La IA detecta sobre-explicación, sabelotodos, confusión de emojis y más.',
    slug: 'emotional-drain-part-2',
    publishDate: '2025-11-16',
    author: 'Toxic Detector Editorial'
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: articleData.title,
    description: articleData.description,
    datePublished: articleData.publishDate,
    author: {
      '@type': 'Organization',
      name: 'ToxicDetector'
    },
    publisher: {
      '@type': 'Organization',
      name: 'ToxicDetector'
    }
  };
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: 'https://toxicdetector.com/'
      });
    } catch (err) {
      navigator.clipboard.writeText(window.location.href);
      alert('¡Enlace copiado al portapapeles!');
    }
  };
  return <>
      <MetaTags title="¿Por qué algunas personas nos hacen sentir agotados? Parte 2 | ToxicDetector" description="Más patrones sutiles que agotan tu energía. La IA detecta sobre-explicación, sabelotodos, confusión de emojis y más." keywords="agotamiento emocional, vampiros de energía, relaciones tóxicas, análisis IA" canonical={`https://toxicdetector.com/es/blog/${articleData.slug}`} ogType="article" ogImage="https://toxicdetector.com/images/logo.png" schema={[articleSchema]} data-id="element-5271" />

      <div className="flex flex-col w-full min-h-screen bg-white" data-id="element-5272">
        <header className="bg-white/95 backdrop-blur-md border-b border-gray-100 sticky top-0 z-50" data-id="element-5273">
          <div className="max-w-4xl mx-auto px-6 py-5" data-id="element-5274">
            <div className="flex items-center justify-between" data-id="element-5275">
              <Link to="/" className="flex items-center gap-2 group" data-id="element-5276">
                <span className="text-2xl" data-id="element-5277">🚩</span>
                <span className="text-xl font-bold text-gray-900 group-hover:text-red-600 transition-colors" data-id="element-5278">
                  ToxicDetector
                </span>
              </Link>
              <button onClick={handleShare} className="p-2.5 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-5279">
                <Share2 size={20} className="text-gray-600" data-id="element-5280" />
              </button>
            </div>
          </div>
        </header>

        <article className="max-w-4xl mx-auto w-full px-6 py-16" data-id="element-5281">
          <Link to="/" className="inline-flex items-center text-gray-600 text-sm mb-12 hover:text-gray-900 transition-colors group" data-id="element-5282">
            <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-5283" />
            Volver al Inicio
          </Link>

          <header className="mb-16" data-id="element-5284">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 tracking-tight leading-[1.1] text-gray-900" data-id="element-5285">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-500 text-sm gap-3" data-id="element-5286">
              <time dateTime={articleData.publishDate} data-id="element-5287">
                {new Date(articleData.publishDate).toLocaleDateString('es-MX', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-5288">•</span>
              <span data-id="element-5289">{articleData.author}</span>
            </div>
          </header>

          <div className="prose prose-lg max-w-none" data-id="element-5290">
            <p className="text-2xl mb-10 leading-relaxed text-gray-700 font-medium" data-id="element-5291">
              Bienvenidos de nuevo a la Parte 2 de nuestra serie sobre
              agotamiento emocional. En la Parte 1, cubrimos los vampiros de
              energía obvios. Ahora profundizamos en los patrones más sutiles.
            </p>

            <section className="mb-16" data-id="element-5292">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-5293">
                1️⃣ El Sobre-Explicador
              </h2>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-5294">
                Alguien que responde preguntas simples con novelas y ata tu
                energía con detalles innecesarios.
              </p>
            </section>

            <section className="mb-16" data-id="element-5295">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-5296">
                2️⃣ El Sabelotodo
              </h2>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-5297">
                No importa lo que digas, esta persona lo sabe mejor o lo ha
                tenido peor. Un comportamiento clásico de "One-Upper".
              </p>
            </section>

            <section className="mb-16" data-id="element-5298">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-5299">
                3️⃣ Confusión de Emojis
              </h2>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-5300">
                Usar emojis pasivo-agresivos como 🙂 o 🙃 en contextos serios
                para crear confusión.
              </p>
            </section>
          </div>

          <div className="bg-red-600 rounded-2xl p-12 md:p-16 text-center text-white shadow-xl mt-16" data-id="element-5301">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight" data-id="element-5302">
              Protege tu energía.
            </h2>
            <p className="text-red-100 mb-10 text-xl leading-relaxed max-w-2xl mx-auto" data-id="element-5303">
              No dejes que te agoten. Descubre quién es bueno para ti.
            </p>
            <Link to="/upload" className="inline-block bg-white text-red-600 px-12 py-5 rounded-xl font-bold text-lg hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl hover:scale-105" data-id="element-5304">
              Escanear ahora →
            </Link>
          </div>

          <div className="mt-20" data-id="element-5305">
            <RelatedBlogPosts posts={[{
            title: '¿Por qué algunas personas nos hacen sentir agotados?',
            description: 'Aprende cómo la IA de Toxic Detector detecta la comunicación unilateral.',
            slug: 'emotional-drain-relationships-ai',
            emoji: '😮‍💨'
          }, {
            title: '7 Señales de Gaslighting',
            description: 'Descubre 7 señales de gaslighting que nuestra IA detecta al instante.',
            slug: '7-signs-of-gaslighting',
            emoji: '💀'
          }]} data-id="element-5306" />
          </div>
        </article>

        <footer className="bg-gray-900 text-white py-16 mt-24" data-id="element-5307">
          <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-5308">
            <p className="text-gray-400 text-sm" data-id="element-5309">
              © {new Date().getFullYear()} ToxicDetector. Todos los derechos
              reservados.
            </p>
          </div>
        </footer>
      </div>
    </>;
}